import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";

export class EntityScoresWidgetDropdownItemViewModel extends ListItemViewModel {
  ignorePaging: Boolean = false;
  reverse: Boolean = false;
  urlFilter: String = '';
  key: String = '';
  linkModel: BaseLinkModel;
  analyticsName: String;

  constructor(model: EntityScoresWidgetDropdownItemViewModel, linkModel: BaseLinkModel) {
    super(model);

    this.reverse = model.reverse;
    this.ignorePaging = model.ignorePaging;
    this.urlFilter = model.urlFilter;
    this.key = model.key;
    this.linkModel = linkModel;
    this.analyticsName = model.analyticsName;
  }
}
